import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import ArticleDetail from './pages/ArticleDetail';
import ArticleEditGutenberg from './pages/ArticleEditGutenberg';
import ArticleCreateGutenberg from './pages/ArticleCreateGutenberg';
import CategoryPage from './pages/CategoryPage';
import SearchPage from './pages/SearchPage';
import NotFound from './pages/NotFound';
import Footer from './components/Footer';

import { ActiveCategoryProvider } from './contexts/ActiveCategoryContext';

function App() {
  return (
    <ActiveCategoryProvider>
      <Router>
        <Topbar />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:slug" element={<ArticleDetail />} />
          <Route path="/create" element={<ArticleCreateGutenberg />} />
          <Route path="/:slug/edit" element={<ArticleEditGutenberg />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </Router>
    </ActiveCategoryProvider>
  );
}

export default App;
